import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DroppableTileList from './DroppableTileList.jsx';
import { tileShape, filterShape } from '../shapes';
import { TabWithPlaceholder } from './TabWithPlaceholder.jsx';
import { TilesWrapper } from '../StyledComponents';

const DroppableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const ProofTabContainer = ({
  activeFilters,
  activeStatus,
  addTileToDigest,
  changeTileStatus,
  handleMenuAction,
  isUserSiteAdmin,
  moveTileBackToPlan,
  tiles,
  dndContext,
  pageNumber,
}) => {
  return (
    <TabWithPlaceholder tiles={tiles}>
      <TilesWrapper>
        <DroppableContainer>
          <DroppableTileList
            activeFilters={activeFilters}
            activeStatus={activeStatus}
            addTileToDigest={addTileToDigest}
            canAddTile={false}
            changeTileStatus={changeTileStatus}
            handleMenuAction={handleMenuAction}
            hasEmptyTileFillers={true}
            isUserSiteAdmin={isUserSiteAdmin}
            moveTileBackToPlan={moveTileBackToPlan}
            tileDigestPlanDate={null}
            tiles={tiles}
            dndContext={dndContext}
            pageNumber={pageNumber}
            pageSize={tiles.length}
            showAllItems={true}
          />
        </DroppableContainer>
      </TilesWrapper>
    </TabWithPlaceholder>
  );
};

ProofTabContainer.propTypes = {
  activeFilters: filterShape,
  activeStatus: PropTypes.string.isRequired,
  addTileToDigest: PropTypes.func.isRequired,
  changeTileStatus: PropTypes.func.isRequired,
  handleMenuAction: PropTypes.func,
  isUserSiteAdmin: PropTypes.bool,
  moveTileBackToPlan: PropTypes.func,
  tileContainerClick: PropTypes.func,
  tiles: PropTypes.arrayOf(tileShape),
  dndContext: PropTypes.object,
  pageNumber: PropTypes.number,
};
